import React from 'react';
import { Icon } from '@iconify/react';

import { Box } from '@mui/material';

function UserOnline({ userOnline }) {
  return (
    <Box
      display="flex"
      alignItems="center"
      px={2}
      py={1}
      borderRadius={2}
      color="#1a237e"
      data-slot="user-online"
      sx={{ boxShadow: 3 }}
    >
      <Box position="relative" width={24} height={24}>
        <Icon icon="mdi:account-group" width="24" height="24" style={{ color: '#4caf50' }} />
        <Box
          position="absolute"
          top={-6}
          right={-8}
          bgcolor="#4caf50"
          color="white"
          fontSize="10px"
          px={0.5}
          borderRadius="8px"
          minWidth="16px"
          textAlign="center"
          lineHeight="16px"
        >
          {userOnline ?? '...'}
        </Box>
      </Box>
    </Box>
  );
}

export default UserOnline;
